import { render, staticRenderFns } from "./Forest.vue?vue&type=template&id=a9f18d76&scoped=true&"
import script from "./Forest.vue?vue&type=script&lang=js&"
export * from "./Forest.vue?vue&type=script&lang=js&"
import style0 from "./Forest.vue?vue&type=style&index=0&id=a9f18d76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f18d76",
  null
  
)

export default component.exports